// 토큰은 여기 두지 않는다. 서버가 httpOnly 쿠키로 주고, 자바스크립트는 읽지 못한다.
// XSS 가 나도 가져갈 토큰이 없다 — 이 콘솔의 토큰으로는 완전삭제·원격제어·정산까지 된다.
//
// 여기 남기는 것은 "로그인한 적 있다" 는 표시뿐이다. 자격증명이 아니라서 새어도 쓸모가
// 없고, 이것만으로 화면 전환을 즉시 판단해 로그인 화면이 한 번 번쩍이는 것을 막는다.
// 표시가 낡았으면 첫 요청이 401 로 답하고 인터셉터가 로그인으로 보낸다.
const KEY = "csms.signed_in";

export function markSignedIn(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    /* 저장 실패해도 동작한다 — 화면이 한 번 더 확인할 뿐이다. */
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}

export function hasSession(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}
